import { useContext } from 'react'

import BulkSelectionContext from 'contexts/BulkSelectionContext'

const useBulkSelection = () => {
  const context = useContext(BulkSelectionContext)

  if (context === undefined) {
    throw new Error(
      'useBulkSelection must be used within a BulkSelectionContext.Provider',
    )
  }

  return {
    items: context.items,
    selected: context.selected,
    setSelected: context.setSelected,
    isSelected: context.isSelected,
    toggle: context.toggle,
    toggleAll: context.toggleAll,
    allSelected: context.allSelected,
    someSelected: context.someSelected,
  }
}

export default useBulkSelection
